import React, { useCallback } from "react";
import { Form, Image } from "semantic-ui-react";
import { useDropzone } from "react-dropzone";
import { useFormik } from "formik";
import { initialValues, validationSchema } from "./ClientDBcreatorForm.form";
import { ClientDB_API } from "../../../../api";
import { useAuth } from "../../../../hooks";
import "./ClientDBcreatorForm.scss";

const clientController = new ClientDB_API();

export function ClientDBcreatorForm(props) {
  const { onClose, onReload, client } = props;

  const { accessToken } = useAuth();

  const formik = useFormik({
    initialValues: initialValues(client),
    validationSchema: validationSchema(),
    validationOnChange: false,
    onSubmit: async (formValue) => {
      try {
        if (!client) {
          await clientController.createClient(accessToken, formValue);
        } else {
          await clientController.updateClient(
            accessToken,
            client._id,
            formValue,
          );
        }

        await onReload();
        await onClose();
      } catch (error) {
        throw error;
        // console.log('Error:', error);
      }
    },
  });

  const onDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        const validMimeTypes = ["image/jpeg", "image/png"];
        if (validMimeTypes.includes(file.type)) {
          formik.setFieldValue("miniature", URL.createObjectURL(file));
          formik.setFieldValue("file", file);
        } else {
          console.log("Tipo de archivo no soportado:", file.type);
        }
      }
    },
    [formik],
  );

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/jpeg": [".jpeg", ".jpg"],
      "image/png": [".png"],
    },
    onDrop,
    multiple: false,
  });

  const getMiniature = () => {
    if (formik.values.file) {
      return formik.values.miniature;
    } else if (formik.values.miniature) {
      // si viene del servidor es que estamos actualizando
      return `${formik.values.miniature}`;
    }
    return null;
  };

  return (
    <Form className="client-form" onSubmit={formik.handleSubmit}>
      <div className="client-form__miniature" {...getRootProps()}>
        <input {...getInputProps()} />
        {getMiniature() ? (
          <Image size="small" src={getMiniature()} />
        ) : (
          <div>
            <span>Arrastra tu miniatura</span>
          </div>
        )}
      </div>
      <Form.Input
        name="title"
        placeholder="Titulo del curso"
        onChange={formik.handleChange}
        value={formik.values.title}
        error={formik.errors.title}
      />
      <Form.Input
        name="url"
        placeholder="link del curso"
        onChange={formik.handleChange}
        value={formik.values.url}
        error={formik.errors.url}
      />
      <Form.TextArea
        name="description"
        placeholder="Descripción del curso"
        onChange={formik.handleChange}
        value={formik.values.description}
        error={formik.errors.description}
      />

      <Form.Input
        name="client"
        placeholder="Nombre del cliente"
        onChange={formik.handleChange}
        value={formik.values.client}
        error={formik.errors.client}
      />

      <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
        {!client ? "Crear Cliente" : "Actualizar"}
      </Form.Button>
    </Form>
  );
}
